function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dfXMLID_4_"
}, /*#__PURE__*/React.createElement("path", {
  id: "dfXMLID_2_",
  d: "M49 11.1l-5.5-5.4.5-.5 5 5.1 5-5.1.5.5z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "dfXMLID_5_",
  className: "dfst0",
  d: "M-26 0h16v16h-16z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "dfXMLID_6_"
}, /*#__PURE__*/React.createElement("path", {
  id: "dfXMLID_3_",
  className: "dfst1",
  d: "M-20.5 5.5l-5.3 5.2-5.2-5.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "dfXMLID_1_",
  className: "dfst2",
  d: "M-26 0h16v16h-16z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "dfXMLID_7_"
}, /*#__PURE__*/React.createElement("path", {
  id: "dfXMLID_9_",
  d: "M8 11L2.7 5.7l.6-.6L8 9.8l4.7-4.7.6.6z"
}));

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-menu-down",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.eacdf427.svg";
export { ForwardRef as ReactComponent };